export default {
  pathPrefix: 'gsc_ga4',
  items: [
    {
      label: 'GSC Properties',
      href: '/gsc_ga4/gsc_properties',
      icon: 'fa-solid fa-magnifying-glass-chart',
      activePath: 'gsc_ga4/gsc_properties'
    },
    {
      label: 'GSC Pages',
      href: '/gsc_ga4/gsc_pages',
      icon: 'fa-solid fa-file-lines',
      activePath: 'gsc_ga4/gsc_pages'
    },
    {
      label: 'GA4 Properties',
      href: '/gsc_ga4/ga4_properties',
      icon: 'fa-solid fa-chart-line',
      activePath: 'gsc_ga4/ga4_properties'
    },
    {
      label: 'GA4 Pages',
      href: '/gsc_ga4/ga4_pages',
      icon: 'fa-solid fa-file-code',
      activePath: 'gsc_ga4/ga4_pages'
    }
  ]
}
